import { ByteParser } from '@internetarchive/field-parsers';
import { MetadataField } from '../metadata-field';
/**
 * ByteField is a unit-specific number field that
 * returns a value in bytes
 *
 * @export
 * @class ByteField
 * @extends {MetadataField<Byte, ByteParser>}
 */
export class ByteField extends MetadataField {
    constructor(rawValue) {
        super(ByteParser.shared, rawValue);
    }
}
//# sourceMappingURL=byte.js.map